import { redactFlightEvent } from './flightRedact'

const DEFAULT_CAPACITY = 200
/** Capacity used when Flow preset is active in the panel. */
export const FLOW_CAPACITY = 500

function nowWallClock () {
  const d = new Date()
  const pad = (n, w = 2) => String(n).padStart(w, '0')
  const ms = pad(d.getMilliseconds(), 3)
  return `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.${ms}`
}

function safeJson (value) {
  try {
    return JSON.parse(JSON.stringify(value))
  } catch {
    return { __nonSerializable: true }
  }
}

const state = {
  enabled: false,
  capacity: DEFAULT_CAPACITY,
  seq: 0,
  events: [],
  subscribers: new Set(),
}

export function isFlightRecorderEnabled () {
  return state.enabled === true
}

export function setFlightRecorderEnabled (enabled) {
  state.enabled = enabled === true
  notify()
}

export function configureFlightRecorder ({ capacity } = {}) {
  const n = Number(capacity)
  if (Number.isFinite(n) && n >= 50 && n <= 2000) state.capacity = Math.floor(n)
}

function notify () {
  for (const fn of state.subscribers) {
    try {
      fn()
    } catch {
      // ignore
    }
  }
}

export function subscribeFlightRecorder (fn) {
  state.subscribers.add(fn)
  return () => state.subscribers.delete(fn)
}

export function clearFlightRecorder () {
  state.events = []
  notify()
}

export function getFlightRecorderSnapshot () {
  return {
    enabled: state.enabled,
    capacity: state.capacity,
    seq: state.seq,
    events: state.events.slice(),
  }
}

/**
 * @param {string} type e.g. 'SAVER:SHOW'
 * @param {object} [meta]
 * @param {string} [source] e.g. 'App.onScreenIdle'
 */
export function recordFlightEvent (type, meta = undefined, source = undefined) {
  if (!state.enabled) return

  const evt = {
    id: ++state.seq,
    ts: Date.now(),
    t: nowWallClock(),
    p: typeof performance !== 'undefined' && performance.now ? Math.round(performance.now() * 1000) / 1000 : null,
    type: String(type || 'UNKNOWN'),
    source: source ? String(source) : undefined,
    meta: meta != null ? safeJson(meta) : undefined,
  }

  state.events.push(evt)
  if (state.events.length > state.capacity) {
    state.events.splice(0, state.events.length - state.capacity)
  }
  notify()
}

export function flightEventsAsJsonLines () {
  const snap = getFlightRecorderSnapshot()
  return snap.events.map((e) => JSON.stringify(e)).join('\n')
}

/**
 * JSONL with mandatory redaction (for Copy / Export).
 * @param {object} [opts] - passed to redactFlightEvent
 * @returns {string}
 */
export function flightEventsAsRedactedJsonLines (opts = {}) {
  const snap = getFlightRecorderSnapshot()
  return snap.events.map((e) => JSON.stringify(redactFlightEvent(e, opts))).join('\n')
}

